import React from 'react';
import {defaultTemplate} from 'core/hoc';
import { Tooltip as ReactTooltip } from "react-tooltip";
import { NumericTextBox } from '@progress/kendo-react-inputs';
import '@progress/kendo-react-intl'
import { observer } from 'mobx-react';

const NumericInputTemplate = defaultTemplate((props) => {
    const { t, defaultValue, value, onChange, onBlur, onFocus, format, label, max, min, required, className, disabled, name, spinners, showChangeFlag, toolTipPlace, previousValue, isNiko, nikoInputData  /*customRef*/ } = props;

    const showLabel = props.showLabel === undefined ? true : props.showLabel;

    const requiredMark = required ? <span className="validation__mark">*</span> : null;
    const handleFocus = (event) => {event.target.select();}

    const TooltipContent = observer(({ initianValue, history, fieldName }) => {
        if (!history || history.fieldName !== fieldName) return null;

        const date = new Date(history.eventDate + "Z");
        const formattedDate = date.toLocaleString('en-US', {
        month: '2-digit',
        day: '2-digit',
        year: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        hour12: true
        }).replace(',', '');

        return (
        <div>
            <div>Previous: {initianValue ? initianValue : 'blank'}</div>
            <div style={{ fontSize: '11px', opacity: 0.75 }}>
            {history ? history.userName + ', ' + formattedDate : '—'}
            </div>
        </div>)
    });

    return (
        <div onFocus={handleFocus}>
            {showLabel && <div className='form__group__label'>{t(label)}{requiredMark}</div>}
            <div className='input__wrapper'>
                {showChangeFlag && (
                    isNiko ? 
                    <React.Fragment>
                        <ReactTooltip positionStrategy="fixed" id={"registerTip" + nikoInputData.fieldName + nikoInputData.patientTemplate.id}  place={toolTipPlace} delayShow={600} render={() => 
                        <TooltipContent initianValue={nikoInputData.initialValue} history={nikoInputData.item.history} fieldName={nikoInputData.fieldName} /> }/>
                        <i className="input--change--text opacity-50" data-tooltip-id={"registerTip" + nikoInputData.fieldName + nikoInputData.patientTemplate.id} onMouseEnter={async () => await nikoInputData.getFieldHistory(nikoInputData.item, nikoInputData.fieldName, nikoInputData.currentValue)} data-tooltip-content="" ></i>
                    </React.Fragment>
                    :
                    <React.Fragment>
                        <ReactTooltip positionStrategy="fixed" id="registerTipItemChanged" place={toolTipPlace} />
                        <i data-tooltip-content={`Previous: ${previousValue ? previousValue : "blank"}`} data-tooltip-id="registerTipItemChanged" className='input--change--text'></i>
                        </React.Fragment>
                )}
                <NumericTextBox 
                    className={className}
                    name={name}
                    max={max}
                    min={min}
                    format={format}
                    disabled={disabled}
                    onChange={onChange}
                    onBlur={onBlur}
                    value={value}
                    defaultValue={defaultValue}
                    spinners={spinners}
                    onFocus={onFocus}
                    //ref={customRef}
                />
            </div>
        </div>
    )
});

export default NumericInputTemplate;
